"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clear = exports.removeFailed = exports.removeSuccess = exports.removeRequest = exports.fetchFailed = exports.fetchSuccess = exports.fetchRequest = exports.FolderTreeActions = void 0;
const ActionTypes = require("../../actionTypes/congrid/files");
const _FolderTreeActions = require("../../modules/files/tree/actions");
exports.FolderTreeActions = _FolderTreeActions.default('congrid');
function fetchRequest(id) {
    return {
        type: ActionTypes.FETCH_REQUEST,
        payload: id
    };
}
exports.fetchRequest = fetchRequest;
function fetchSuccess(payload) {
    return {
        type: ActionTypes.FETCH_SUCCESS,
        payload
    };
}
exports.fetchSuccess = fetchSuccess;
function fetchFailed(payload) {
    return {
        type: ActionTypes.FETCH_FAILED,
        payload
    };
}
exports.fetchFailed = fetchFailed;
function removeRequest(project, file) {
    return {
        type: ActionTypes.REMOVE_REQUEST,
        payload: {
            project,
            file
        }
    };
}
exports.removeRequest = removeRequest;
function removeSuccess() {
    return {
        type: ActionTypes.REMOVE_SUCCESS
    };
}
exports.removeSuccess = removeSuccess;
function removeFailed(payload) {
    return {
        type: ActionTypes.REMOVE_FAILED,
        payload
    };
}
exports.removeFailed = removeFailed;
function clear() {
    return {
        type: ActionTypes.CLEAR
    };
}
exports.clear = clear;
//# sourceMappingURL=files.js.map